import type React from 'react';
import { useNavigate } from 'react-router-dom';
import { contactIconsMap, contactsVerbMap, type ContactType } from '@widgets/contacts/contact-edit/constans.tsx';
import { SelectingIdsIconCheckbox } from '@widgets/shared/SelectingIconCheckbox/index.ts';
import { Close } from '@shared/assets';
import { isPhoneNumber } from '@shared/helpers';
import type { ContactItem } from '@shared/types/contacts';
import { Card, DropdownItem, useMenuDropdown } from '@shared/ui';
import { IconButton } from '@shared/ui/buttons';
import { DropdownMenuWithButton } from '@shared/ui/menus/dropdown-menu/index.ts';
import { TextOverflow } from '@shared/ui/TextOverflow/index.tsx';
import * as st from './styles.module.scss';

type Props = {
  contact: ContactItem;
  isSelectList: boolean;
  onDelete: () => void;
};

export const ContactCard: React.FC<Props> = ({ contact, isSelectList, onDelete }) => {
  const { menuRef, handleAction, handleToggleDropdown, isMenuOpen } = useMenuDropdown({});
  const { value, type, description, id } = contact;
  const navigate = useNavigate();

  const ContactIcon = contactIconsMap[type as ContactType];

  const handleClickEdit = () => {
    localStorage.setItem('editContact', JSON.stringify(contact));
    navigate('edit');
  };

  return (
    <Card className={st.card}>
      <div className={st.wrapper}>
        {isSelectList && <SelectingIdsIconCheckbox name={'contacts'} id={id} />}
        <div className={st.info}>
          <div className={`${st.info__icon} ${st[type]}`}>{ContactIcon}</div>
          <div className={st.info__value}>
            <p>{contactsVerbMap[type as ContactType]}</p>
            <TextOverflow noWrap className={st.value}>
              {isPhoneNumber(value) ? `+${value}` : value}
            </TextOverflow>
          </div>
        </div>
        {isSelectList ? (
          <DropdownMenuWithButton
            isMenuOpen={isMenuOpen}
            onMenuBtnClick={handleToggleDropdown}
            menuRef={menuRef}
          >
            <DropdownItem onClick={handleAction(handleClickEdit)}>Изменить</DropdownItem>
            <DropdownItem onClick={handleAction(onDelete)}>Удалить</DropdownItem>
          </DropdownMenuWithButton>
        ) : (
          <IconButton
            variant="transparent"
            type="button"
            onClick={onDelete}
            title="Удалить контакт"
          >
            <Close />
          </IconButton>
        )}
      </div>
    </Card>
  );
};
